import React from "react";
import "./App.css";
import { ContentProvider } from "./context/ContentContext";
import Header from "./components/Header";
import Hero from "./components/Hero";
import WhyCommunication from "./components/WhyCommunication";
import Framework from "./components/Framework";
import Programs from "./components/Programs";
import FinalCTA from "./components/FinalCTA";
import Footer from "./components/Footer";

function App() {
  return (
    <ContentProvider>
      <div className="App">
        <Header />
        <main>
          <Hero />
          <WhyCommunication />
          <Framework />
          <Programs />
          <FinalCTA />
        </main>
        <Footer />
      </div>
    </ContentProvider>
  );
}

export default App;
